import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { EPresence } from 'src/api/users-api';
import { useSetPresence } from 'src/services/api/users/presence';
import { Flex, FlexColumn } from 'src/components/flex';

export default function OnlineOutOfHoursBanner() {
    const { mutate: setPresence, isLoading } = useSetPresence();

    return (
        <Alert
            data-testid="online-out-of-hours-banner"
            severity="success"
            color="success"
            sx={{
                '& .MuiAlert-message': { width: '100%' },
                '& .MuiAlert-icon': { paddingTop: '10px' },
            }}
        >
            <Flex width="100%" justifyContent="space-between" alignItems="center">
                <FlexColumn>
                    <Typography fontWeight="bold" color="success.dark">
                        Online outside working hours
                    </Typography>
                    <Typography variant="body2" color="success.dark">
                        You manually set yourself online.
                    </Typography>
                </FlexColumn>

                <Button
                    variant="outlined"
                    color="success"
                    size="small"
                    disabled={isLoading}
                    data-testid="online-out-of-hours-set-away"
                    onClick={() => setPresence({ presence: EPresence.AWAY })}
                >
                    Set Away
                </Button>
            </Flex>
        </Alert>
    );
}
